<template>
    <div id="app">
        <router-view/>
    </div>
</template>


<script>

    import jQuery from "jquery";
    const $ = jQuery;
    window.$ = $;

    import {Validator} from 'vee-validate';
    import {MLBuilder} from 'vue-multilanguage';
    import cookieconsent from '@/plugins/cookieconsent/cookieconsent.min.js';


    export default {
        name: 'App',

        components: {
             cookieconsent
        },

        async created() {
            let autoAuthToken = this.$route.query.autoAuthToken;
            if (!!autoAuthToken) {
                await this.$store.dispatch('authByToken', autoAuthToken);

                let query = Object.assign({}, this.$route.query);
                delete query.autoAuthToken;
                this.$router.replace({query});
            }
        },


        mounted() {

            Validator.localize('en', this.$ml.get('errors'));

            // modals
            $('.window-wrapper .btn-close, .window-wrapper .button-close-window').on('click', function(e){
                // e.preventDefault();
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            });

            $('.form-field-input input').each(function(){
                if( $(this).val() === '' ) {
                    $(this).closest('.form-field-input').removeClass('filled');
                } else {
                    $(this).closest('.form-field-input').addClass('filled');
                }
            });

            $('.form-field-input input').on('focus keyup', function(){
                $(this).closest('.form-field-input').addClass('filled');
            }).blur(function(){
                if( $(this).val() == '' ) {
                    $(this).closest('.form-field-input').removeClass('filled');
                }
            });

            setTimeout(
                function () {
                    window.cookieconsent.initialise({
                        "palette": {
                            "popup": {
                                "background": "#000",
                            },
                            "button": {
                                "background": "#fff"
                            }
                        },
                        "content": {
                            "message": "Сайт использует файлы cookies и сервис сбора технических данных его посетителей. Продолжая использовать данный ресурс, вы автоматически соглашаетесь с использованием данных технологий",
                            "dismiss": "ОK",
                        }
                    });
                },
                1000
            );

            var screenHeight = $(window).height();
            if( screenHeight < 470 ) {
                $('.nav-mob-wrapper').height(screenHeight - 80);
            }

            $(window).resize(function() {
                screenHeight = $(window).height();
                if( screenHeight < 470 ) {
                    $('.nav-mob-wrapper').height(screenHeight - 80);
                }
            });

        }
    }
</script>

<style>
    @import 'css/style.css';
    @import 'plugins/slick/slick.css';
    @import "plugins/slick/slick-theme.css";
    @import "plugins/cookieconsent/cookieconsent.min.css";
    @import "css/fonts.googleapis.css";


</style>

